import * as yup from 'yup';

export const descriptionSummarySchema = yup.object({
    description: yup.string().label('description'),
});

export type descriptionSummarySchemaType = yup.InferType<typeof descriptionSummarySchema>
